export const randomValueFromArray = (array) => {
   if (!array) return false
   const randomIndex = Math.floor(Math.random() * array.length);
   const randomValue = array[randomIndex];
   return randomValue
}